import Icon from '@/components/ui/AppIcon';

interface Benefit {
  id: string;
  icon: string;
  title: string;
  description: string;
}

interface BenefitsSectionProps {
  className?: string;
}

const BenefitsSection = ({ className = '' }: BenefitsSectionProps) => {
  const benefits: Benefit[] = [
    {
      id: '1',
      icon: 'CurrencyDollarIcon',
      title: 'Выгодные цены',
      description: 'Оптовые цены с дополнительными скидками при покупке коробами. Экономьте до 20% на крупных заказах.',
    },
    {
      id: '2',
      icon: 'TruckIcon',
      title: 'Быстрая доставка',
      description: 'Доставка по всему Казахстану в течение 2-5 рабочих дней. Бесплатная доставка при заказе от 100 000 ₸.',
    },
    {
      id: '3',
      icon: 'ShieldCheckIcon',
      title: 'Гарантия качества',
      description: 'Все товары сертифицированы и соответствуют стандартам качества. Гарантия возврата в течение 14 дней.',
    },
    {
      id: '4',
      icon: 'ClipboardDocumentListIcon',
      title: 'Простая система заказов',
      description: 'Подайте заявку онлайн, наш менеджер свяжется с вами для подтверждения и уточнения деталей заказа.',
    },
    {
      id: '5',
      icon: 'UserGroupIcon',
      title: 'Персональный менеджер',
      description: 'Каждому клиенту назначается персональный менеджер для консультаций и помощи в оформлении заказов.',
    },
    {
      id: '6',
      icon: 'DocumentTextIcon',
      title: 'Полный пакет документов',
      description: 'Предоставляем все необходимые документы: накладные, счета-фактуры, сертификаты качества.',
    },
  ];

  return (
    <section className={`bg-muted py-12 lg:py-16 ${className}`}>
      <div className="mx-auto max-w-7xl px-4 lg:px-6">
        <div className="mb-12 text-center">
          <h2 className="mb-4 font-heading text-2xl font-semibold text-text-primary lg:text-3xl">
            Почему выбирают нас
          </h2>
          <p className="mx-auto max-w-2xl text-base text-text-secondary lg:text-lg">
            Мы предлагаем комплексные решения для оптовых закупок с индивидуальным подходом к каждому клиенту
          </p>
        </div>
        
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="group overflow-hidden rounded-md bg-card p-6 shadow-sm transition-all duration-250 hover:-translate-y-1 hover:shadow-md"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 transition-colors duration-250 group-hover:bg-primary">
                <Icon
                  name={benefit.icon as any}
                  size={24}
                  className="text-primary transition-colors duration-250 group-hover:text-primary-foreground"
                />
              </div>
              
              <h3 className="mb-2 font-heading text-lg font-semibold text-text-primary">
                {benefit.title}
              </h3>
              
              <p className="text-sm leading-relaxed text-text-secondary">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;